import { ca } from '@cian/analytics';

export function trackAdvancedFiltersApplied(label: string | undefined) {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'popup_more_param_show_objects_click',
    label,
  });
}
